<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "EximCeisaClientLogin",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  